export default {"src":"/_next/static/media/calendarFour_64.0e0cb427.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};